function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var IsuccessCircleWhite = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    notChangeable: true,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.522 17.523 22 12 22C6.477 22 2 17.522 2 12ZM11.7275 15.6054L16.2955 9.60543C16.6305 9.16643 16.5455 8.53943 16.1065 8.20443C15.6655 7.86943 15.0385 7.95543 14.7045 8.39443L10.9205 13.3634L9.28748 11.2774C8.94748 10.8414 8.31748 10.7654 7.88348 11.1064C7.44848 11.4464 7.37248 12.0754 7.71248 12.5094L10.1445 15.6164C10.3345 15.8584 10.6245 16.0004 10.9315 16.0004H10.9385C11.2485 15.9984 11.5395 15.8524 11.7275 15.6054Z",
    fill: "white"
  }));
});